@use "../../../../scss/settings/colors";

.page_title {
  color: colors.$base-black;
  font-size: 26px;
}

.document_header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .actions_group {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.add_button {
  width: 50px !important;
  height: 45px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0;
  border-radius: 20% !important;
  background-color: colors.$gray-variant !important;
}

.tabs {
  :global(.MuiTab-root) {
    text-transform: none;
    padding: 8px 16px;
    color: colors.$text-black-3;
    font-size: 14px;
    border-radius: 6px;
    margin: 0 4px;
    transition: color 0.2s ease, background-color 0.2s ease;

    &:hover {
      color: colors.$brand-purple;
      // background-color: colors.$light-purple;
    }

    &:global(.Mui-selected) {
      color: colors.$brand-purple;
      font-weight: 500;
      //background-color: colors.$light-purple;
    }
  }

  :global(.MuiTabs-indicator) {
    background-color: colors.$brand-purple;
  }
}

.tab_container {
  margin-bottom: 15px;

  .tabs_section {
    flex: 1;
  }
}

.upload_container {
  position: relative;
  width: fit-content;

  .upload_form {
    position: absolute;
    top: 0;
    left: 100%;
    margin-left: 8px;
    z-index: 1000;
    background-color: colors.$base-white;
    width: 430px;
    height: 165px;
  }
}

.form_box {
  position: absolute;
  z-index: 5;
  animation: pulse 0.5s ease-in-out;
  border-color: colors.$brand-purple;
}

.form_upload {
  border-color: colors.$brand-purple;
  margin-left: 2rem;
}

.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: colors.$gray-variant-16;

  .documentViewText {
    text-decoration-color: colors.$brand-purple;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 6px;
    font-size: 14px;
  }

  h3.documentViewText {
    font-size: 15px;
    line-height: 24px;
    cursor: pointer;
  }

  a, h3 {
    text-decoration: underline;
    color: colors.$brand-purple;

    &:hover {
      text-decoration: none;
    }

  }

}

.separator {
  color: colors.$gray-variant-16;
}

.card_list_view_container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 5px 8px;
  background-color: colors.$gray-variant-21;
  border-radius: 8px;
  border: 1px solid colors.$gray-variant-4;
}

.variant_btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 3px 6px;
    font-family: 'Medium Inter', sans-serif;
    font-size: 12px;
    text-transform: none;
    color: colors.$dark-blue;
    background-color: transparent;
    border-color: transparent;
    border-radius: 10px;
    transition: color 0.3s, background-color 0.3s;

  &[disabled]{
    opacity: 0.5;
  }

  &.variant_btn_active, &:hover {

    &:not([disabled]) {
      color: colors.$base-white;
      background-color: colors.$purple-light-5;
    }

  }

  svg {
    width: 16px;
    height: 16px;
    fill: currentColor !important;
  }

}
